import { Stack } from "@mui/material";
import DocumentItem from "../DocumentItem";
import { ClientDocumentDto } from "types/generated/models";

export default function DocumentList({
    documents,
    dataTestIdSuffix,
}: Readonly<{
    documents: ClientDocumentDto[];
    dataTestIdSuffix: string;
}>) {
    return (
        <Stack spacing={2} data-test-id={`section_document_list_${dataTestIdSuffix}`}>
            {documents.map((document) => (
                <DocumentItem key={document.id} document={document} />
            ))}
        </Stack>
    );
}
